import { render, staticRenderFns } from "./MyMentoraRequests.vue?vue&type=template&id=73fa865c&"
import script from "./MyMentoraRequests.vue?vue&type=script&lang=js&"
export * from "./MyMentoraRequests.vue?vue&type=script&lang=js&"
import style0 from "./MyMentoraRequests.vue?vue&type=style&index=0&id=73fa865c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports